import { render, staticRenderFns } from "./largeDevice.vue?vue&type=template&id=bc694024&scoped=true"
import script from "./largeDevice.vue?vue&type=script&lang=js"
export * from "./largeDevice.vue?vue&type=script&lang=js"
import style0 from "./largeDevice.vue?vue&type=style&index=0&id=bc694024&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc694024",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc694024')) {
      api.createRecord('bc694024', component.options)
    } else {
      api.reload('bc694024', component.options)
    }
    module.hot.accept("./largeDevice.vue?vue&type=template&id=bc694024&scoped=true", function () {
      api.rerender('bc694024', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/largeDevice.vue"
export default component.exports